export const TAILOR_LOADING = 'TAILOR_LOADING';
export const TAILOR_FULFILLED = 'TAILOR_FULFILLED';
export const TAILORS_FULFILLED = 'TAILORS_FULFILLED';
